import { useState } from "react";
import logo from "../assets/logoMain.png";

function GscLogin(props) {
  const [pass, setPass] = useState("");
  const p = props;
  return (
    <div className="relative flex min-h-[100dvh] w-full flex-col items-center justify-center bg-slate-100 px-4 py-10 pb-24">
      <div
        className="pointer-events-none absolute inset-0 overflow-hidden"
        aria-hidden="true"
      >
        <div className="absolute -left-32 top-0 h-72 w-72 rounded-full bg-indigo-400/20 blur-3xl" />
        <div className="absolute -right-24 bottom-32 h-80 w-80 rounded-full bg-blue-300/25 blur-3xl" />
      </div>

      <div className="relative z-[1] w-full max-w-md">
        <div className="rounded-2xl border border-white/60 bg-white/90 p-8 shadow-lg shadow-slate-900/5 backdrop-blur-md">
          <div className="mb-8 flex flex-col items-center text-center">
            <img
              src={logo}
              alt="GSC"
              className={`h-[110px] w-auto object-contain drop-shadow-sm ${
                p.loginLoading ? "animate-bounce" : ""
              }`}
            />
            <h1 className="mt-4 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
              GSC login
            </h1>
            <p className="mt-1 max-w-xs text-sm text-slate-500">
              Administrator access to class monitoring
            </p>
          </div>

          <form
            className="flex flex-col gap-3"
            onSubmit={(e) => {
              e.preventDefault();
              p.gscAuth(pass);
            }}
          >
            <label className="sr-only" htmlFor="gsc-pass">
              Password
            </label>
            <input
              id="gsc-pass"
              className="peaci-input"
              type="password"
              placeholder="Password"
              onChange={(e) => setPass(e.target.value)}
              value={pass}
              autoComplete="current-password"
            />
            <button type="submit" className="peaci-btn-primary mt-1 w-full py-3 text-base">
              Sign in
            </button>
          </form>
        </div>
      </div>

      <footer className="fixed bottom-0 left-0 right-0 z-10 border-t border-slate-200/80 bg-slate-900/95 px-3 py-2.5 text-center text-[11px] text-slate-300 backdrop-blur-sm sm:text-xs">
        Developed by <span className="font-semibold text-white">Mellhabib M. Angni</span>
      </footer>
    </div>
  );
}

export default GscLogin;
